import { __decorate, __metadata } from "tslib";
import { TypedStorage } from "./TypedStorage";
import { injectable } from "inversify";
let TypedInMemoryStorage = class TypedInMemoryStorage extends TypedStorage {
    constructor(key, defaultValue) {
        super(InMemoryStorage.default, key, defaultValue);
    }
};
TypedInMemoryStorage = __decorate([
    injectable(),
    __metadata("design:paramtypes", [String, Object])
], TypedInMemoryStorage);
export { TypedInMemoryStorage };
class InMemoryStorage {
    constructor() {
        this._map = new Map();
    }
    static get default() {
        if (!InMemoryStorage._default)
            InMemoryStorage._default = new InMemoryStorage();
        return InMemoryStorage._default;
    }
    get length() {
        return this._map.size;
    }
    clear() {
        this._map.clear();
    }
    getItem(key) {
        return this._map.get(key) ?? null;
    }
    key(index) {
        if (index >= this._map.size)
            return null;
        return Array.from(this._map.keys())[index] ?? null;
    }
    removeItem(key) {
        this._map.delete(key);
    }
    setItem(key, value) {
        this._map.set(key, value);
    }
}
//# sourceMappingURL=TypedInMemoryStorage.js.map